module.exports = __webpack_public_path__ + "assets/img/1.f6cdff6f.jpg";